<template>
  <el-dialog
    :title="$t('system::common::changePwd_title')"
    width="640px"
    :visible.sync="show"
    :close-on-click-modal="false"
  >
    <el-form ref="changePwdForm" label-position="right" label-width="130px" class="form" :rules="rules" :model="form">
      <el-form-item :label="$t('system::common::changePwd::oldPassword') + '：'" prop="oldPassword">
        <el-input
          style="width: 360px"
          type="password"
          v-model="form.oldPassword"
          :placeholder="$t('system::common::changePwd::oldPassword_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('system::common::changePwd::newPassword') + '：'" prop="newPassword">
        <el-input
          style="width: 360px"
          type="password"
          v-model="form.newPassword"
          :placeholder="$t('system::common::changePwd::newPassword_placeholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('system::common::changePwd::comfirmPassword') + '：'" prop="comfirmPassword">
        <el-input
          style="width: 360px"
          type="password"
          v-model="form.comfirmPassword"
          :placeholder="$t('system::common::changePwd::comfirmPassword_placeholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="show = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit" :loading="loading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import JSEncrypt from 'jsencrypt'
import { changePassword } from '@/server/login'
import { redictToLogin} from '@/utils/index';

import { pubKey } from '@/utils/pubkey'
export default {
  props: {
    value: {},
  },
  data() {
    let validateNewPassword = (rule, value, callback) => {
      if (!/(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value)) {
        callback(new Error(this.$t('system::common::changePwd::16位数字加字母组合')))
      } else {
        callback()
      }
    }
    let validateVerifyNewPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error(this.$t('system::common::changePwd::与新密码不一致')))
      } else {
        callback()
      }
    }
    return {
      show: false,
      form: {
        oldPassword: '',
        newPassword: '',
        comfirmPassword: '',
      },
      loading: false,
      rules: {
        oldPassword: [
          { required: true, message: this.$t('system::common::changePwd::oldPassword_placeholder'), trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: this.$t('system::common::changePwd::newPassword_placeholder'), trigger: 'blur' },
          { validator: validateNewPassword, trigger: 'blur' },
        ],
        comfirmPassword: [
          {
            required: true,
            message: this.$t('system::common::changePwd::comfirmPassword_placeholder'),
            trigger: 'blur',
          },
          { validator: validateVerifyNewPassword, trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    show(val) {
      this.$emit('input', val)
      if (!val) {
        this.form = {
          oldPassword: '',
          newPassword: '',
          comfirmPassword: '',
        }
        if (this.$refs.changePwdForm) {
          this.$refs.changePwdForm.clearValidate()
        }
      }
    },
    value(val) {
      this.show = val
    },
  },

  methods: {
    passwordEncrypt(password) {
      let jsencrypt = new JSEncrypt()
      jsencrypt.setPublicKey(pubKey)
      return jsencrypt.encrypt(password.trim())
    },
    async changePwd() {
      const { oldPassword, newPassword } = this.form
      this.loading = true
      const { data } = await changePassword({
        oldPassword: this.passwordEncrypt(oldPassword),
        newPassword: this.passwordEncrypt(newPassword),
        userId: this.$store.state.user.userId,
      })
      this.loading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::change_success'))
        this.show = false
        document.cookie = `domain=0;domain=.shoplus.net;expires=${new Date(0).toUTCString()}`
        setTimeout(()=> {
          redictToLogin()
        },2000)
      }
    },
    submit() {
      this.$refs.changePwdForm.validate(valid => {
        if (valid) {
          this.changePwd()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  width: 480px;
  margin: auto;
}
</style>
